import { syncSession } from '@/lib/sync';
import { isAuthenticationRequiredSyncError } from '@/lib/sync/error-utils';
import type { SessionId } from '@/schemas';
import { enqueueSyncJob, registerSyncPlugin } from '../plugins.js';
import type { SyncPlugin } from '../plugins.js';

export const SESSION_SYNC_PLUGIN_KEY = 'session-events';

const sessionSyncPlugin: SyncPlugin<SessionId> = {
  key: SESSION_SYNC_PLUGIN_KEY,
  createJobKey(sessionId: SessionId) {
    return `session:${sessionId}`;
  },
  createMetadata(sessionId: SessionId) {
    return {
      entity: 'session-events',
      scope: String(sessionId),
      source: 'session-sync-plugin',
    };
  },
  async run(sessionId: SessionId) {
    await syncSession(sessionId);
  },
  shouldRetry(error) {
    return !isAuthenticationRequiredSyncError(error);
  },
};

const registerSessionPlugin = registerSyncPlugin as (
  plugin: SyncPlugin<SessionId>,
) => SyncPlugin<SessionId>;
registerSessionPlugin(sessionSyncPlugin);

export function enqueueSessionSync(sessionId: SessionId): void {
  const enqueue = enqueueSyncJob as (key: string, scope: SessionId) => void;
  enqueue(SESSION_SYNC_PLUGIN_KEY, sessionId);
}
